// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** C 端按门店查询商品列表 用户扫码门店二维码进入后，携带 storeId 获取该门店在售商品（支持分页、关键字与类目筛选） GET /api/v1/app/products */
export async function AppProductControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppProductControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputClientProductDtoArray>(
    "/api/v1/app/products",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** C 端获取商品详情 用户点击商品进入详情页，携带 productId 获取商品详情（含在售 SPU / SKU / 分期套餐与类目编码） GET /api/v1/app/products/${param0} */
export async function AppProductControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppProductControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputClientProductDetailDto>(
    `/api/v1/app/products/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
